import { render } from "./orgCourseAnalyseCreate.vue?vue&type=template&id=3e05fd23&scoped=true"
import script from "./orgCourseAnalyseCreate.vue?vue&type=script&lang=js"
export * from "./orgCourseAnalyseCreate.vue?vue&type=script&lang=js"

import "./orgCourseAnalyseCreate.vue?vue&type=style&index=0&id=3e05fd23&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e05fd23"]])

export default __exports__